import { render, staticRenderFns } from "./integrations-lead-api.vue?vue&type=template&id=f438af96"
import script from "./integrations-lead-api.vue?vue&type=script&lang=js"
export * from "./integrations-lead-api.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports